import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const gradientClasses = `
  h-1.5
  rounded-[20px]
  bg-gradient-to-r
    from-[rgba(58,200,212,0.48)]
    via-[rgba(239,131,255,0.48)]
    to-[rgba(70,58,213,0.48)]
  transition-[width] duration-500 ease-[cubic-bezier(0.17,0.67,0.88,0.17)]
`;

const BaseProgressBar = ({ className, animationClass = '', widthStyle }) => (
  <div className={clsx('w-full overflow-hidden', className)}>
    <div className={clsx(gradientClasses, animationClass)} style={widthStyle} />
  </div>
);

BaseProgressBar.propTypes = {
  className: PropTypes.string,
  animationClass: PropTypes.string,
  widthStyle: PropTypes.object.isRequired,
};

export default BaseProgressBar;
